import { green } from "@ant-design/colors"
import { faBoltAuto } from "@fortawesome/pro-duotone-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tooltip } from "antd"

const AutomationFollowUpIcon = () => {
  return <Tooltip title='There are active proposal follow-ups'>
    <FontAwesomeIcon icon={faBoltAuto} color={green.primary} size="lg" />
  </Tooltip>
}

export default AutomationFollowUpIcon